import { Pipe, PipeTransform } from '@angular/core';
import { MediaRecording, MediaRecordingStatus } from 'src/app/models/media-recording.model';

type MediaRecordingStatusLabelInput = MediaRecording | MediaRecordingStatus | 'stopping';

@Pipe({
  name: 'mediaRecordingStatusLabel',
  standalone: true,
  pure: true,
})
export class MediaRecordingStatusLabelPipe implements PipeTransform {
  private readonly local_recording_status_labels: Record<MediaRecording['recording_status'], string> = {
    recording: 'Grabando',
    paused: 'Pausada',
    stopped: 'Detenida',
    pending_upload: 'Pendiente de subir',
    uploading: 'Subiendo',
    upload_failed: 'Error de subida',
    processing: 'Procesando',
    completed: 'Completada',
    failed: 'Fallida',
  };

  private readonly active_recording_status_labels: Record<string, string> = {
    stopping: 'Deteniendo',
  };

  private readonly media_recording_status_labels: Record<MediaRecording['recording_status'], string> = {
    recording: 'Grabando',
    paused: 'Pausada',
    stopped: 'Detenida',
    pending_upload: 'Pendiente de subir',
    uploading: 'Subiendo fragmentos',
    upload_failed: 'Error de subida',
    processing: 'Procesando',
    completed: 'Completada',
    failed: 'Fallida',
  };

  transform(value: MediaRecordingStatusLabelInput | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }

    return this.resolveMediaRecordingStatusLabel(value);
  }

  private resolveMediaRecordingStatusLabel(recording_or_status: MediaRecordingStatusLabelInput): string {
    if (typeof recording_or_status === 'string') {
      return (
        this.local_recording_status_labels[recording_or_status as MediaRecordingStatus] ??
        this.active_recording_status_labels[recording_or_status] ??
        recording_or_status
      );
    }

    return this.getMediaRecordingStatusLabel(recording_or_status);
  }

  private getMediaRecordingStatusLabel(recording: MediaRecording): string {
    if (recording.server_processing_status === 'queued') {
      return 'En cola';
    }

    if (recording.server_processing_status === 'processing') {
      return 'Procesando';
    }

    if (recording.youtube_upload_status === 'uploading') {
      return 'Subiendo a YouTube';
    }

    if (recording.youtube_upload_status === 'failed') {
      return 'Error subida YouTube';
    }

    if (recording.server_processing_status === 'failed') {
      return 'Error procesamiento';
    }

    if (recording.recording_status === 'upload_failed') {
      return 'Error de subida';
    }

    if (recording.recording_status === 'failed') {
      return 'Error procesamiento';
    }

    return this.media_recording_status_labels[recording.recording_status] ?? recording.recording_status;
  }
}
